module.exports = __webpack_public_path__ + "img/home-bg-th.9452625f.png";